import { formatDate } from '@angular/common';
import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { HttpClient } from '@microsoft/signalr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi } from 'ag-grid-community';
import { SubscriptionLike } from 'rxjs';
import { ConfigSummary, SmtpConfigurationService } from 'src/app/services/common/SmtpConfigurationService';

@Component({
  selector: 'app-sa-emailconfig-history',
  templateUrl: './sa-emailconfig-history.component.html',
  styleUrls: ['./sa-emailconfig-history.component.scss']
})
export class SaEmailconfigHistoryComponent implements OnInit {

  private subfetchConfigAsync?: SubscriptionLike;
  private subfetchByIdAsync?: SubscriptionLike;
  rowClassRules: { grid_removeactions: string; };
  context: any;

  SMTPRecords: any;
  VersionHistory: FormGroup;
  columnDefs;
  operations;
  collapesedOrNot: boolean;
  gridApi: GridApi;
  selectedRow;
  rowData;
  advanceSearch;
  tempoperations;
  // gridApi: GridApi;
  // gridColumnApi: any
  // gridOptions: any;
  // paginationPageSize = AppConsts.GridDisplayCount;
  // columnDefs: any;
  // components: any;
  // operations: Operation[];
  frameworkComponents: any;
  serviceAPI: any
  GoogleValue: any
  editable: boolean;
  dateformat: any

  constructor(
    //private readonly ngModal: NgbActiveModal,
    private readonly smtpService: SmtpConfigurationService,
    private fb: FormBuilder,
    // public Datashare: DatashareService,

    @Inject(LOCALE_ID) private locale: string,
    public modalRef: NgbActiveModal,

  ) { }

  ngOnDestroy(): void {
    if (this.subfetchConfigAsync)
      this.subfetchConfigAsync.unsubscribe();
    if (this.subfetchByIdAsync)
      this.subfetchByIdAsync.unsubscribe();
  }


  ngOnInit(): void {
    this.collapesedOrNot = false;

    this.columnDefs = [
      {
        "field": "VersionNo",
        "headerName": "Version Number",

      },
      {
        "field": "EmailID",
        "headerName": "Email Address"
      },
      {
        "field": "CreatedDate",
        "headerName": "Updated On"
      }
    ];
    this.setOperations();
    this.editable = false;
    this.FetchAllSMTPRecords()
    this.BuildVersionHistory()
  }
  BuildVersionHistory() {
    this.VersionHistory = this.fb.group({
      EmailID: [null, []],
      EmailPwd: [null, []],
      EmailDisplayName: [null, []],
      EmailAccountTypeCode: [null, []],
      MicrosoftClientID: [null, []],
      MicrosoftClientSecret: [null, []],
      MicrosoftTenantID: [null, []],
      SMTPHost: [null, []],
      SMTPPort: [null, []],
      FileName: [null, []],
      FileExt: [null, []],
      VersionNo: [null, []]
    })
  }

  FetchAllSMTPRecords() {
    this.subfetchConfigAsync = this.smtpService.GetSMTPRecordList().subscribe(result => {
      this.SMTPRecords = result;
      this.rowData = this.SMTPRecords;
    })
  }
  setOperations() {
    let tempoperations = [
      {
        "name": "View",
        "id": "view"
      }];
    this.operations = tempoperations.map(operation => {
      return (operation && (operation.id === 'add' || operation.id === 'view_modal')) ? { name: operation.name, callback: this[operation.id], self: this, disabled: 'false' } : { name: operation.name, callback: this[operation.id], self: this }
    });
  }

  view(element) {
    var EmailConfigID =this['self'].selectedRow.EmailConfigID;  //element.EmailConfigID
    this.subfetchByIdAsync = this['self'].smtpService.FetchRecordByIDAsync(EmailConfigID).subscribe(result => {
      this['self'].VersionHistory.patchValue(result);
      this['self'].GoogleValue = result.FileName + "" + result.FileExt
      this['self'].VersionHistory.patchValue({
        VersionNo: result.VersionNo + ".0"
      })
      
    })
    
  }

  cancelversionHistory() {
    this.modalRef.dismiss();
  }
  onSetGridApi(gridApi) {
    this.gridApi = gridApi;
  }

  onCallbackOperation(opr) {
    opr.callback();
  }

  onSelectionChanged(event) {
    this.selectedRow = this.gridApi.getSelectedRows() ? this.gridApi.getSelectedRows()[0] : null;
  }
  onRowDoubleClicked(event) {
    var EmailConfigID =this.selectedRow.EmailConfigID;  //element.EmailConfigID
    this.subfetchByIdAsync = this.smtpService.FetchRecordByIDAsync(EmailConfigID).subscribe(result => {
      this.VersionHistory.patchValue(result);
      this.GoogleValue = result.FileName + "" + result.FileExt;
      this.VersionHistory.patchValue({
        //VersionNo: this['self'].VersionNo + ".0"
        VersionNo:event.data.VersionNo,
       
      })
      this.VersionHistory.disable();
    })

  }
}
